import { useEffect } from 'react';
import { pagesConfig } from '../router';
import { usePreloadImages } from './usePreloadImages';
import { useNextPageName } from './useNextPageName';

export const usePreloadNextPage = () => {
  const nextPage = useNextPageName();
  const nextPageConfig = pagesConfig[nextPage];

  useEffect(() => {
    if (!nextPageConfig) return;
    nextPageConfig.component.preload();
  }, [nextPageConfig]);

  usePreloadImages(nextPageConfig?.images);
};
